import { memo, ReactNode } from 'react';
import { Divider, Stack, SxProps, Theme } from '@mui/material';
import DialogBody from 'components/dialog/DialogBody';
import DialogContent from 'components/dialog/DialogContent';
import DialogTitle from 'components/dialog/DialogTitle';
import DialogButtons from 'components/dialog/DialogButtons';
import PositiveButton from 'components/cmn/PositiveButton';

interface IOneButtonDialogProps {
  title?: string;
  content: ReactNode | string;
  confirmTitle?: string;
  confirmSx?: SxProps<Theme>;
  handleConfirm: () => void;
}
function OneButtonDialog({
  title = '알림',
  content,
  confirmTitle = '확인',
  handleConfirm,
  ...props
}: IOneButtonDialogProps): JSX.Element {
  return (
    <DialogContent width={{ desktop: 500 }} height={{ desktop: 295 }}>
      <DialogTitle marginBottom="23px" hideCloseButton>
        {title}
      </DialogTitle>
      <Divider sx={theme => ({ border: `1px solid ${theme.palette.mind.divider}` })} />
      <DialogBody marginTop="30px" style={{ overflowX: 'hidden', overflowY: 'scroll !important' }}>
        {content}
      </DialogBody>
      <DialogButtons marginTop="0px">
        <Stack direction="row" spacing={2}>
          <PositiveButton
            title={confirmTitle}
            sx={props.confirmSx || { width: 150, height: 52 }}
            onClick={handleConfirm}
          />
        </Stack>
      </DialogButtons>
    </DialogContent>
  );
}

export default memo(OneButtonDialog);
